import Vue from "vue";
import Component from "vue-class-component";
import type { ElForm } from "element-ui/types/form";
import { Prop, Watch } from "vue-property-decorator";
import uuid4 from "uuid";
import { cloneDeep } from "lodash";
import AddButton from "../shopDisplaySketchMap/addButton";
import { IPSService } from "@/services/ipsServices";
import { RenovationColor, RenovationColorList } from "@/views/components/styleConfig";
import ShopDisplay from "@/views/components/shopDisplaySketchMap/display";
import ShopDisplayEdit from "@/views/components/shopDisplaySketchMap/displayEdit";
import imagePreview from "@/views/components/imgPreview";
import { noop, QinggerLibUtils } from "@/util";
import { Functions } from "@/library/utils/functions";
import validateParams from "@/library/utils/paramFilter";

const isset = QinggerLibUtils.isset;
export const morentupian = "https://ssl-picture.tenyun.runsasoft.com/morentupian.jpg";

const CenterInfoService = ["getMemberCenterInfo", "getMemberCenterInfo", "siteMemberCenterInfo"];
const CenterSaveService = ["memberCenterSave", "memberCenterSave", "siteMemberCenterSave"];

@Component({
	components: {
		ShopDisplayEdit,
		ShopDisplay,
	},
})
export default class Personal extends Vue {
	@Prop({ default: RenovationColor.redOrangeWhite })
	themeCode: number;
	@Prop()
	fromPage: number;
	@Prop()
	mode: number;

	// @ts-expect-error
	theme = RenovationColorList[this.themeCode];

	$refs: {
		form: ElForm;
	};

	activedIndex = -1;

	data: DisplayData[] = [];
	copyData: DisplayData[] = [];

	connectedClass = [];

	@Watch("data", { deep: true })
	watchData() {
		this.activedIndex = this.data.findIndex((v) => v.isActived) || 0;
	}

	async mounted() {
		this.mode === 2 && (this.connectedClass = await this.getAttributeList());
		this.getData();
	}

	/**
	 * 获取关联分类
	 */
	public getAttributeList(): Promise<any> {
		return IPSService.getAttributeList().then((res) => {
			return isset(res, "list") ? res.list : [];
		});
	}

	getData(loading?) {
		IPSService[CenterInfoService[this.mode]]({
			postParams: {
				sgId: Number.parseInt(this.$route.params.id),
				siteId: Number.parseInt(this.$route.params.siteId),
			},
		}).then(
			(response) => {
				const list = response.list.map((value, index) => {
					this.$set(value, "_key", uuid4());
					value = Object.assign({}, value, { isActived: false });
					switch (value.fieldType) {
						case "backGround":
							!(value as DisplayBgData).desc.color && ((value as DisplayBgData).desc.color = "#ffffff");
							return value;
						case "member":
							(value as DisplayMemberData).desc = Object.assign({ isPre: false, brandGroupConfig: { brandGroupList: [], defalutShowNumber: 2, isOpen: 1, showType: 1 } }, value.desc);
							return value;
						case "iconMenu":
							const iconLink = (value as DisplayIconMenuData).desc.list.filter((v) => (v.page === 3 || v.page === 6 || v.page === 16) && v.pageId);
							if (iconLink.length) {
								Promise.all(this.getMiniName(iconLink)).then((result) => {
									result.forEach((r) => {
										(value as DisplayIconMenuData).desc.list.forEach((f) => {
											if (r.pageId === f.pageId) {
												f.pageName = r.pageName;
											}
										});
									});
								});
							}
							(value as DisplayIconMenuData).desc.list = (value as DisplayIconMenuData).desc.list.map((v, i) => {
								v.url = v.url || morentupian;
								return v;
							});
							value.desc = Object.assign(value.desc, { isDefault: false });
							return value;
						case "HoverIcon":
							const miniPage = (value as DisplayHoverIconData).desc.list.filter((v) => v.page === 16);
							if (miniPage.length) {
								Promise.all(this.getMiniName(miniPage)).then((result) => {
									result.forEach((r) => {
										(value as DisplayHoverIconData).desc.list.forEach((f) => {
											if (r.pageId === f.pageId) {
												f.pageName = r.pageName;
											}
										});
									});
								});
							}
							return value;
						default:
							return value;
					}
				});
				this.data = list;
				this.copyData = cloneDeep(this.data);
				if (loading) {
					const maxNum = Math.max(
						...list
							.filter((v) => {
								return v.fieldType != "blank";
							})
							.map((v) => v.ygswpId),
					);
					const indexAdd = list.findIndex((el) => el.ygswpId === maxNum);
					this.data = this.data.map((v, i) => {
						v.isActived = indexAdd === i;
						this.activedIndex = indexAdd;
						return v;
					});
					this.$nextTick(() => {
						if (this.$el.querySelector(".is-actived")) {
							this.$el.querySelector(".is-actived").scrollIntoView({ behavior: "smooth", block: "start" });
						}
					});
					loading.close();
				}
			},
			() => {
				if (loading) {
					loading.close();
				}
			},
		);
	}

	getMiniName(arr = []): Promise<any>[] {
		arr = arr.filter((v) => !!v.pageId);
		return arr.map((v, i) => {
			return IPSService[Number.parseInt(this.$route.params.siteId) ? "siteMicroPageInfo" : "miniPageInfo"]({
				postParams: {
					pageId: v.pageId,
				},
			});
		});
	}

	// 保存
	save(isPre = 0) {
		const { index, message } = this.validateData();
		let list = validateParams(cloneDeep(this.data));
		if (list[index]) {
			this.data = this.data.map((v, i) => {
				v.isActived = index === i;
				this.activedIndex = index;
				return v;
			});
			if (this.mode === 1) {
				this.$nextTick(() => {
					message && this.$message.warning(message);
					this.$el.querySelector(".is-actived").scrollIntoView({ behavior: "smooth", block: "start" });

					if ((this.$refs.form.$refs[this.data[index].fieldType] as ElForm).$refs.form) {
						((this.$refs.form.$refs[this.data[index].fieldType] as ElForm).$refs.form as ElForm).validate(noop);
					}
				});
				return;
			}
		}
		this.$nextTick(() => {
			list = list.filter((v) => {
				if (v.fieldType === "text") {
					return ((v as DisplayTextData).desc.title && (v as DisplayTextData).desc.title.trim()) || ((v as DisplayTextData).desc.content && (v as DisplayTextData).desc.content.trim());
				} else {
					return v;
				}
			});
			const postParams = {
				sgId: Number.parseInt(this.$route.params.id),
				siteId: Number.parseInt(this.$route.params.siteId),
				list,
				showType: 3,
			};
			let loading = null;
			if (postParams.siteId) {
				loading = this.$loading({
					lock: true,
					text: "请稍等...",
					spinner: "el-icon-loading",
					background: "rgba(225,225,225,0.3)",
				});
			}
			if (!isPre) {
				if (this.mode === 2) {
					this.$confirm("请确保当前只有您在操作当前画面，否则可能导致保存布局操作覆盖其他人正在进行的作业").then(
						(result) => {
							if (result === "confirm") {
								const filterList = list.map((i) => {
									return { ygswpId: i.ygswpId, fieldType: i.fieldType };
								});
								const postParams = {
									showType: 3,
									siteId: +this.$route.params.siteId,
									list: filterList,
								};
								IPSService.componentLayoutSave({ postParams: validateParams(postParams) }).then(
									(res) => {
										if (res && res.result) {
											this.getData(loading);
											this.$message.success("保存成功");
										} else {
											this.$message.error("保存失败");
										}
									},
									() => {
										if (loading) {
											loading.close();
										}
										this.$message.error("保存出错，请稍后重试");
									},
								);
							}
						},
						() => {
							if (loading) {
								loading.close();
							}
						},
					);
				}
				if (this.mode === 1) {
					IPSService[CenterSaveService[this.mode]]({ postParams: validateParams(postParams) }).then(
						(response) => {
							if (response.result) {
								this.$message.success("保存成功");
							} else {
								this.$message.error("保存失败");
							}
							if (loading) {
								this.getData(loading);
							}
						},
						() => {
							if (loading) {
								loading.close();
							}
						},
					);
				}
			} else {
				IPSService.siteMemberConfigDisplay({ postParams: validateParams(postParams) }).then(
					(response) => {
						if (loading) {
							loading.close();
						}
						imagePreview.open({ img: response.disPlayUrl }).catch(() => {});
					},
					() => {
						if (loading) {
							loading.close();
						}
					},
				);
			}
		});
	}

	saveFlag(val) {
		if (val) {
			this.getData();
		}
	}

	// 数据校验
	validateData(): { index: number; message: string } {
		this.data = this.data.map((value) => {
			value.isActived = false;
			return value;
		});
		return Functions.validateDisplayData(this.data);
	}

	changeCopyData(val) {
		this.copyData = val;
	}
	// 添加
	onAddItem(val: ItemArray) {
		const activedIndex = this.data.findIndex((v) => v.isActived);
		this.data = this.data.map((v, i) => {
			v = Object.assign(v, { isActived: false });
			return v;
		});

		val[val.length - 1].isActived = true;
		if (activedIndex === -1) {
			this.data = this.data.concat(val);
			this.copyData = this.copyData.concat(val);
		} else {
			this.data.splice(activedIndex + 1, 0, ...val);
			this.copyData.splice(activedIndex + 1, 0, ...val);
		}
		this.scrollToActived();
	}
	// 滚动到选定位置
	scrollToActived() {
		this.$nextTick(() => {
			if (this.$el.querySelector(".is-actived")) {
				this.$el.querySelector(".is-actived").scrollIntoView({ behavior: "smooth", block: "start" });
			}
		});
	}
	get dealPage() {
		console.log(this.fromPage);
		return this.fromPage && (this.fromPage === 1 || this.fromPage === 2);
	}
	render(h) {
		return (
			<section class={{ "nav-Menu personal-center": true, "no-padding height-100": this.dealPage }}>
				<div class={{ "nav-container relative-position": true, "no-padding": this.dealPage }} style="height: calc(100% - 51px)">
					{this.dealPage && (
						<div class="bottom-button" ref="bottomButton">
							<AddButton v-model={this.data} fromPage={this.fromPage} onAdd={this.onAddItem.bind(this)} class="flex" />
						</div>
					)}
					<div class={{ "left-phone overflow-auto-y bg-white": true, "wid-240": !this.dealPage, "shop-left-phone absolute ": this.dealPage }}>
						<ShopDisplay v-model={this.data} themeCode={Number(this.themeCode)} fromPage={this.fromPage} actData={this.copyData} onChangeData={this.changeCopyData.bind(this)} />
					</div>
					<ShopDisplayEdit
						data={null}
						attrButeList={this.connectedClass.map((v) => {
							v.value_name = v.attrName;
							v.value_no = v.attrCode;
							v.class_code = v.attrCode;
							v.isLeafe = !v.list || !v.list.length;
							return v;
						})}
						v-model={this.data[this.activedIndex]}
						themeCode={Number(this.themeCode)}
						onSaveFlag={this.saveFlag.bind(this)}
						fromPage={this.mode == 1 ? 2 : 7}
						ref="form"
					/>
				</div>
				<div class="bottom-save">
					<el-button type="primary" class="wid-48 r-mr-14" onClick={this.save.bind(this, 0)}>
						{this.mode === 2 ? "保存布局" : "保存"}
					</el-button>
					{this.mode === 2 && (
						<span class="scopeSpan" onClick={this.save.bind(this, 1)}>
							预览
						</span>
					)}
				</div>
			</section>
		);
	}
}
